import { type SupabaseClient } from "@supabase/supabase-js";
import { type Dayjs } from "dayjs";

import { type TrainerAssignedClient } from "@fitness-app/data-models/entities/TrainerStats";
import { type Database } from "@fitness-app/supabase";

export type GhostClientWithInfo = TrainerAssignedClient & {
  trainee: {
    email: string;
    firstName: string;
    lastName: string;
  } | null;
};

export async function fetchTrainerGhostClients(
  supabase: SupabaseClient<Database>,
  month: Dayjs,
  trainerId: string,
): Promise<GhostClientWithInfo[]> {
  if (!trainerId) {
    return [];
  }

  // First, get all trainer_stats IDs for this month and trainer
  const { data: statsData } = await supabase
    .from("trainer_stats")
    .select("id, date")
    .eq("month", month.format("YYYY-MM"))
    .eq("trainerId", trainerId)
    .throwOnError();

  if (!statsData || statsData.length === 0) {
    return [];
  }

  const dayIds = statsData.map((stat) => stat.id);

  // Then fetch all assigned clients that are ghosts for these days
  const { data: assignedClients } = await supabase
    .from("trainer_assigned_client")
    .select("*, trainee:traineeId(email, firstName, lastName)")
    .in("dayId", dayIds)
    .eq("ghost", true)
    .throwOnError()
    .overrideTypes<GhostClientWithInfo[]>();

  return assignedClients || [];
}
